import { CREDIT_LINE } from "@/lib/brand";

/**
 * App-wide signature footer.
 * `floating` keeps it pinned at the bottom regardless of content height.
 */
export default function CreditFooter({ floating = false, className = "" }) {
  const base =
    "text-[11px] text-slate-400 tracking-wide text-center select-none";
  if (floating) {
    return (
      <div className={`fixed bottom-1 inset-x-0 ${base} ${className}`}>
        {CREDIT_LINE}
      </div>
    );
  }
  return (
    <div className={`mt-8 mb-3 ${base} ${className}`} data-testid="credit-footer">
      {CREDIT_LINE}
    </div>
  );
}
